import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import Owner from '../tract_detail/Owner';
import IOwner from '../IOwner';
import WIContractOwnership from '../tract_detail/WIContractOwnership';
import ContractGenerationOwnerData from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationOwnerData';
import ContractAdHocClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAdHocClause';
import ContractAmendment from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAmendment';
import Acknowledgement from '../leasing/Acknowledgement';
import ContractAddendumClauseXRef from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClauseXRef';
import IContract from './IContract';

export default class SurfaceWaiver implements IContract {
    id: number;
    surfaceWaiverNumber: number;
    name: string;
    createdDate?: Date;
    commitDate?: Date;
    isCommitted?: boolean;
    inHandDate?: Date;
    isInHand?: boolean;
    voidDate?: Date;
    isVoid: boolean;
    createdByUserId: number;
    leasedByUserId: number;
    leasedBy: string;
    lesseeName: string;
    lesseeAddressLine1: string;
    lesseeAddressLine2: string;
    lesseeCity: string;
    lesseeState: string;
    lesseeZipCode: string;
    lesseePhoneNumber: string;
    lesseeOwnerLookupId?: number;
    originalLessee: string;
    isNotOriginalLessee?: boolean;
    grantorAka: string;
    spouseName: string;
    spouseAkaName: string;
    maritalStatus: string;
    leaseLessorNotes: string;
    fedStateLeaseNumber: string;
    legalDescription: string;
    rteLegalDescription: string;
    grossAcres: number;
    recordDate: Date;
    recordTypeId: number;
    volume: string;
    page: string;
    instrumentNumber: string;
    projectId: number;
    contractDate?: Date;
    effectiveDate?: Date;
    bonusAmount?: number;
    bonusTypeId?: number;
    isFiledByMemo?: boolean;
    isGeneratedLease?: boolean;
    clientDocNumber: string;
    reminderDate?: Date;
    reminderNote: string;
    ownersOnDocument: string;
    ownersAddressOnDocument: string;
    ownersSSNTaxIdOnDocument: string;
    isActive?: boolean;
    recordedDate?: Date;

    // not mapped
    invoiceableLookupId?: number;

    currentHold?: SurfaceWaiverHold;
    surfaceWaiverHolds?: Array<SurfaceWaiverHold>;

    adHocClauses?: Array<ContractAdHocClause>;
    removeClauses?: Array<number>;
    contractClauses?: Array<ContractAddendumClauseXRef>;
    contractAmendments?: Array<ContractAmendment>;
    acknowledgements?: Array<Acknowledgement>;

    tracts?: Array<ContractGenerationTractDetail>;
    owners?: Array<ContractGenerationOwnerData>;
}

export class SurfaceWaiverHold {
    id: number;
    surfaceWaiverId: number;
    surfaceWaiverHoldNumber: number;
    decimalInterest: number;
    waiverDate?: Date;
    primaryTerm: number;
    primaryTermTypeId: number;
    expirationDate: Date;
    bonusPaid: number;
    bonusPaidTypeId: number;
    note: string;
    isPerpetual?: boolean;
    additionalConsideration: number;
    description: string;
    isActive?: boolean;
    isHistorical?: boolean;

    // not mapped
    totalBonusPaid: number;
    wiOwners?: Array<Owner>;
    contractOwnerships?: Array<WIContractOwnership>;
    surfaceOwner: IOwner;
    ownershipId?: number;
    contractLookupId?: number;
    sourceWaiverHoldId?: number;
    acknowledgements?: Array<Acknowledgement>;
}


// WEBPACK FOOTER //
// ./src/models/contract_types/SurfaceWaiver.ts